import React, {FC, useState} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Component.
 */

export const OfflineBanner: FC = () => {
  const theme = useUserTheme();
  const content = useRotatingContent();
  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.grey.shade50}
      priority={BannerPrioritiesEnum.INFORMATION}
    >
      <BannerIcon iconName="karlitoSmall" />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="pushoffline-banner-title">Offline</Trans>
        </BannerContentTitle>
        {content}
      </BannerContent>
    </Banner>
  );
};

function useRotatingContent() {
  const [content] = useState(makeRandomContent());
  return content;
}

function makeRandomContent() {
  return bannerDescriptions[Math.floor(Math.random() * bannerDescriptions.length)];
}

/*
 * Content.
 */

const bannerDescriptions = [
  <Trans id="pushoffline-banner-content">Front will reconnect when it detects an internet connection.</Trans>,
  // TODO: We want to enable the rest of these descriptions when offline mode is fully rolled out.
  // <Trans id="pushoffline-banner-content1">
  //   Your drafts are saved and messages will send when you&apos;re back online
  // </Trans>,
  // <Trans id="pushoffline-banner-content2">Check your wifi... or don&apos;t! Front still works fine</Trans>,
  // <Trans id="pushoffline-banner-content3">
  //   On a train? On a plane? We save your work so you don&apos;t toil in vain!
  // </Trans>,
  // <Trans id="pushoffline-banner-content4">
  //   Front works offline! Take this unique opportunity to do some focused work
  // </Trans>,
  // <Trans id="pushoffline-banner-content5">
  //   Keep going! Your messages will be sent once you&apos;re back online
  // </Trans>,
  // <Trans id="pushoffline-banner-content6">
  //   There&apos;s no limit to what you can do when you aren&apos;t interrupted by notifications
  // </Trans>,
  // <Trans id="pushoffline-banner-content7">
  //   Also known as &quot;Focus Mode&quot;! Keep working and everything will sync when you&apos;re back online
  // </Trans>
];
